export interface IDataDashboard {
  ejecutionOt: number,
  ot: number,
  mPre: number,
  ejecutionOC: number,
  inspections: number
}

export class   DataDashboard  implements IDataDashboard  {
  ejecutionOt: number = 0;
  ot: number = 0;
  mPre: number = 0;
  ejecutionOC: number = 0;
  inspections: number = 0;
}
